<template>
  <div id="app">
    <navbar v-if="navbar_show"></navbar>
    <router-view v-on:navbar="navbar" v-on:footer="footer"/>
    <footer-bar v-if="footer_show"></footer-bar>
  </div>
</template>

<script>
import Navbar from './components/navbar/Navbar'
import Footer from "./components/footer/Footer"
export default {
  components: {
    "navbar": Navbar,
    "footer-bar": Footer,
  },
  data(){
    return {
      navbar_show: true,
      footer_show: true,
    }
  },
  methods:{
      //是否显示头部
      navbar:function (bool) {
        this.navbar_show = bool;
      },
      //是否显示底部
      footer:function (bool) {
          this.footer_show = bool;
      }
  }
};
</script>

<style lang="scss">
@import '@/assets/main.scss';
</style>